import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'summary-list',
    templateUrl: './summary-list.component.html',
    styleUrls: ['./summary-list.component.scss'],
    standalone: false
})
export class SummaryListComponent implements OnInit {
  @Input() title: string;
  @Input() options: string[] = [];
  constructor() {}

  ngOnInit() {}
}
